function cov_4pqtcpuwr() {
  var path = "/app/src/components/snippet-default/components/skeleton/skeleton.tsx";
  var hash = "6cb23c1724825a0bb0ae67d64cf06b03409403c8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/snippet-default/components/skeleton/skeleton.tsx",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 24
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 12,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 24
          },
          end: {
            line: 6,
            column: 25
          }
        },
        loc: {
          start: {
            line: 6,
            column: 30
          },
          end: {
            line: 13,
            column: 1
          }
        },
        line: 6
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6cb23c1724825a0bb0ae67d64cf06b03409403c8"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_4pqtcpuwr = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_4pqtcpuwr();
import cn from 'classnames';
import React from 'react';
import styles from './styles.css';
cov_4pqtcpuwr().s[0]++;
export var Skeleton = function Skeleton() {
  cov_4pqtcpuwr().f[0]++;
  cov_4pqtcpuwr().s[1]++;
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.container)
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.skeletonStripe)
  }), /*#__PURE__*/React.createElement("div", {
    className: cn(styles.skeletonStripe)
  }));
};